/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Maybe } from '@irian-ro/util-functions';
import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportErrorMessageVO extends JSONable{
  errorMessage: Maybe<string> | undefined = undefined;
}
